import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { rightArrowIcon } from "../../../assets/icons";
import { EMPTY_ARRAY, INDEX, ROUTES } from "../../../constants";
import { selectSelectedSubTab, selectSelectedTab } from "./index";
import { v4 as uuid } from "uuid";
import truncate from "lodash/truncate";

const BLANK_SPACE = " ";
const HYPHEN = "-";
const { HOME } = ROUTES;
const { SECOND, THIRD, FOURTH } = INDEX;

const BreadCrumb = () => {
  const currentPath = window.location.pathname;
  const navigate = useNavigate();
  const selectedTab = useSelector(selectSelectedTab);
  const selectedSubTab = useSelector(selectSelectedSubTab);
  const [tabs, setTabs] = useState(EMPTY_ARRAY);
  const [urlArray, setUrlArray] = useState(EMPTY_ARRAY);

  useEffect(()=>{
    setUrlArray(currentPath.toString().split("/"));
  },[currentPath])

  useEffect(() => {
    if (!selectedTab) {
      urlArray.length > THIRD
        ? setTabs([
            {
              name: urlArray[SECOND],
              shouldReplace: true,
              url: urlArray[SECOND],
            },
          ])
        : setTabs([{ name: urlArray[SECOND], shouldReplace: true }]);
    } else {
      const urlFourth = selectedSubTab || urlArray[FOURTH];
      const urlForSelectedTab = `${urlArray[SECOND]}/${urlArray[THIRD]}/${urlFourth}`;
      setTabs([
        {
          name: urlArray[SECOND],
          shouldReplace: true,
          url: urlArray[SECOND],
        },
        { name: selectedTab.name, shouldReplace: true, url: urlForSelectedTab },
        { name: selectedSubTab || urlArray[FOURTH], shouldReplace: false },
      ]);
    }
  }, [selectedTab, currentPath, selectedSubTab, urlArray]);

  const getTabName = (tab, index) => {
    return index !== SECOND && tab.name
      ? tab.name
          .replace(HYPHEN, BLANK_SPACE)
          .replace(/(^[a-z]| [a-z])/g, (letter) => letter.toUpperCase())
      : tab.name;
  };

  return (
    <div className="items-center hidden lg:flex pl-6 max-w-[60%]">
      <button
        className="text-6 text-gray-400 hover:text-gray-500"
        onClick={() => navigate(HOME)}
      >
        Tava
      </button>
      <div className="mx-4">
        <img
          src={rightArrowIcon}
          className="min-w-[20px]"
          alt="right-arrow-icon"
        />
      </div>
      {tabs.map((tab, index) => (
        <React.Fragment key={uuid()}>
          {index !== tabs.length - SECOND || !selectedTab && urlArray.length > THIRD ? (
            <>
              <button
                className="text-6 text-gray-400 hover:text-gray-500"
                onClick={() => {
                  if (tab.shouldReplace) {
                    if (tab.url.includes("/Secrets")) {
                      tab.url = tab.url.replace("/Secrets", "/settings");
                    }
                    navigate(`/${tab.url}`);
                  }
                }}
                title={getTabName(tab, index)}
              >
                {truncate(getTabName(tab, index), { length: 12 })}

              </button>
              <div className="mx-4">
                <img
                  src={rightArrowIcon}
                  className="min-w-[20px]"
                  alt="right-arrow-icon"
                />
              </div>
            </>
          ) : (
            <span className="text-6 text-gray-400">{getTabName(tab)}</span>
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default BreadCrumb;
